/* 電話番号 */
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from './Paragraph';

interface Props {
  label: string;
  need?: boolean;
  value?: string; // NOTE: format "input1-input2-input3", each max 4, all max 11
  handleChange?: (value: string) => void;
  handleBlur?: () => void;
  message?: string;
  help_msg?: string;
  disabled: boolean;
}

const TelInput: React.FC<Props> = ({
  label,
  need,
  value,
  handleChange,
  handleBlur,
  message,
  help_msg,
  disabled,
}) => {
  const inputValues = value?.split('-') ?? ['', '', ''];

  const handleChangeInput =
    (index: number): React.ChangeEventHandler<HTMLInputElement> =>
    (event) => {
      const targetValue = event.target.value;
      inputValues[index] = targetValue;
      const finalValue = inputValues.join('-');
      handleChange?.(finalValue);
    };

  const handleOnBlur: React.FocusEventHandler<HTMLElement> = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget as Node)) {
      handleBlur?.();
    }
  };

  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      content={
        disabled ? (
          <Paragraph label={value === '--' ? '' : value ?? ''} />
        ) : (
          <>
            <Row onBlur={handleOnBlur}>
              <Col xs={3} className="pr-0">
                <Form.Control
                  type="NUMBER"
                  onChange={handleChangeInput(0)}
                  value={inputValues?.[0]}
                  disabled={disabled}
                />
              </Col>
              <Col xs={1} className="d-flex align-items-center justify-content-center">
                －
              </Col>
              <Col xs={3} className="p-0">
                <Form.Control
                  type="NUMBER"
                  onChange={handleChangeInput(1)}
                  value={inputValues?.[1]}
                  disabled={disabled}
                />
              </Col>
              <Col xs={1} className="d-flex align-items-center justify-content-center">
                －
              </Col>
              <Col xs={3} className="p-0">
                <Form.Control
                  type="NUMBER"
                  onChange={handleChangeInput(2)}
                  value={inputValues?.[2]}
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Messages help_msg={help_msg} valid_msg={message} />
          </>
        )
      }
    />
  );
};

export default TelInput;
